import React, { useState, useRef } from 'react';
import { uploadFile } from '../api/api';

export const FileUpload = ({ value, onChange, accept, label, required, previewSmall }) => {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');
  const fileRef = useRef();

  const handleFileSelect = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    setError('');
    try {
      const result = await uploadFile(file);
      onChange(result.url);
    } catch (err) {
      setError("Erreur lors de l'upload du fichier");
    }
    setUploading(false);
  };

  const isVideo = accept && accept.includes('video');

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label} {required && '*'}
      </label>

      {value && (
        <div className={`mb-2 rounded-lg overflow-hidden border border-gray-200 ${previewSmall ? 'inline-block bg-gray-100 p-2' : ''}`}>
          {isVideo ? (
            <video src={value} className="w-full h-40 object-cover" controls />
          ) : (
            <img src={value} alt="Apercu" className={previewSmall ? 'w-20 h-20 object-contain' : 'w-full h-40 object-cover'} />
          )}
        </div>
      )}

      <div className="flex gap-2">
        <button
          type="button"
          onClick={() => fileRef.current?.click()}
          disabled={uploading}
          className="px-4 py-2 bg-pink-50 border border-pink-300 text-pink-700 rounded-lg hover:bg-pink-100 transition text-sm font-medium disabled:opacity-50"
        >
          {uploading ? 'Upload en cours...' : 'Choisir un fichier'}
        </button>
        <input
          ref={fileRef}
          type="file"
          accept={accept || "image/*"}
          onChange={handleFileSelect}
          className="hidden"
        />
        <input
          type="text"
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder="ou coller une URL"
          required={required && !value}
          className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-600 focus:border-transparent text-sm"
        />
      </div>

      {uploading && (
        <div className="mt-2 flex items-center gap-2 text-sm text-pink-600">
          <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
          </svg>
          Upload en cours...
        </div>
      )}

      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};
